import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IFetchWorkspaceAssignmentCountParams {
  days_ago: number;
}

export interface IFetchWorkspaceAssignmentCountResponse {
  assignment_count: string;
}

export default function useFetchWorkspaceAssignmentCount({
  days_ago,
}: IFetchWorkspaceAssignmentCountParams): UseQueryResult<
  IFetchWorkspaceAssignmentCountResponse,
  unknown
> {
  const axios = useAxios();

  const query = useQuery<IFetchWorkspaceAssignmentCountResponse>(
    ["workspace-assignment-count", { days_ago }],
    async (): Promise<IFetchWorkspaceAssignmentCountResponse> => {
      return await axios
        .get(`/v1/workspaces/assignments/count`, {
          params: {
            days_ago,
          },
        })
        .then((r) => {
          return r.data as IFetchWorkspaceAssignmentCountResponse;
        });
    }
  );

  return query;
}
